<template>
  <div class="hint__list" v-if="inputFocus && hintList.length">
    <!--groups-->
    <div v-for="group in hintList" :key="group.title">
      <div class="list-title">
        {{group.title}}
      </div>
      <ul class="ul__hint">
        <li
          v-for="item in group.items"
          :key="item.id || item.label"
          @click="itemClicked(group, item)"
          :class="{ active: item.index === activeIndex }"
          @mouseover="activeIndex = item.index"
        >
          {{item.label}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import { forEach, getValue } from '@/utils/helpers'
  import CyrillicToTranslit from 'cyrillic-to-translit-js'
  const cyrillicToTranslit = new CyrillicToTranslit()

  export default {
    name: 'bimManufacturerHints',
    props: {
      /**
       * Мы в фокусе инпута или нет
       */
      inputFocus: {
        type: Boolean,
        default: false
      },
      /**
       * строка поиска
       */
      search: {
        type: String,
        default: ''
      },
      /**
       * Показывать подсказки по производителям
       */
      showHintManufacturers: {
        type: Boolean,
        default: true
      },
      /**
       * Показывать подсказки по категориям
       */
      showHintCategories: {
        type: Boolean,
        default: true
      },
      /**
       * Префикс для запросов апи
       */
      relativePrefix: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        activeIndex: null,
        manufacturers: [],
        categories: []
      }
    },
    mounted () {
      if (this.showHintCategories) {
        this.getCategoriesData()
      }

      document.addEventListener('keyup', this.onKeyUp)
    },
    beforeDestroy () {
      document.removeEventListener('keyup', this.onKeyUp)
    },
    computed: {
      hintList () {
        if (!this.search) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.activeIndex = null
          return []
        }

        const groups = []
        let index = 0

        const search = String(this.search).toLowerCase()

        groups.push({
          title: 'Поиск',
          type: 'search',
          items: [
            { label: this.search, index }
          ]
        })

        index += 1

        let list = []
        let mGroup = {}

        // categories
        list = []
        mGroup = {
          title: 'Категории',
          type: 'categories',
          items: [
          ]
        }
        this.categories.filter(item => {
          const name = String(item.text).toLowerCase()
          const engName = cyrillicToTranslit.transform(name)
          const ruName = cyrillicToTranslit.reverse(name)

          if (~name.indexOf(search) || ~engName.indexOf(search) || ~ruName.indexOf(search)) {
            list.push(item)
          }
        })

        forEach(list.slice(0, 3), item => {
          mGroup.items.push({ ...item, label: item.text, index })
          index += 1
        })

        if (mGroup.items.length) {
          groups.push(mGroup)
        }
        // end categories

        // manufacturers
        mGroup = {
          title: 'Производители',
          type: 'manufacturers',
          items: []
        }

        forEach(this.manufacturers, item => {
          mGroup.items.push({ ...item, label: item.text, index })
          index += 1
        })

        if (mGroup.items.length) {
          groups.push(mGroup)
        }
        // end manufacturers

        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.activeIndex = 0

        return groups
      }
    },
    methods: {

      // получим категории
      async getCategoriesData () {
        const headers = {}
        headers.Accept = 'application/json'
        headers['Content-Type'] = 'application/json'

        const result = await fetch(`${this.relativePrefix}/web-api/objcategory/all/`, {
          method: 'GET',
          headers
        })
          .then(r => r.json())
          .then(res => res.data)

        this.categories = result.map(item => ({
          id: item.code,
          text: item.name
        }))
      },

      async fetchManufacturers () {
        const headers = {}
        headers.Accept = 'application/json'
        headers['Content-Type'] = 'application/json'

        const result = await fetch(`${this.relativePrefix}/api/passport/companies/search?search=${this.search}&size=5`, {
          method: 'GET',
          headers
        })
          .then(r => r.json())
          .then(r => r.items)
          .catch(e => {})

        this.manufacturers = result.map(item => ({
          ...item,
          id: String(item.id),
          text: item.nameShort || item.nameFull,
          checked: false
        }))
      },

      onKeyUp (e) {
        const groups = this.hintList

        // @todo enter
        if (e.keyCode === 13) {
          this.submitEvent()
          return
        }

        if (!groups.length) {
          return
        }

        const groupItems = groups[groups.length - 1].items
        const maxIndex = groupItems[groupItems.length - 1].index

        // down
        if (e.keyCode === 40) {
          if (this.activeIndex + 1 <= maxIndex) {
            this.activeIndex += 1
          } else {
            this.activeIndex = 0
          }
        }

        // up
        if (e.keyCode === 38) {
          if (this.activeIndex - 1 >= 0) {
            this.activeIndex -= 1
          } else {
            this.activeIndex = maxIndex
          }
        }
      },

      submitEvent () {
        if (this.activeIndex === null) {
          return
        }

        const groups = this.hintList
        let activeGroup = null
        let activeItem = null

        forEach(groups, group => {
          const item = group.items.find(item => item.index === this.activeIndex)

          if (item) {
            activeGroup = group
            activeItem = item
          }
        })

        if (activeItem) {
          this.itemClicked(activeGroup, activeItem)
        }
      },

      itemClicked (group, item) {
        /**
         * Событие клика на элемент подсказки { group, item }
         */
        this.$emit('submit', { group, item })
      }
    },
    watch: {
      search (search) {
        if (search && this.inputFocus && this.showHintManufacturers) {
          this.fetchManufacturers()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .hint__list {
    position: absolute;
    top: 44px;
    left: 0;
    right: 0;
    background: white;
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(0,0,0, .08);
    z-index: 10;
    overflow: hidden;
  }

  .hint__list ul {
    list-style-type: none;
  }

  .hint__list li,
  .list-title {
    padding: 9px 15px;
    font-size: 16px;
    color: #555;
  }

  .hint__list .active {
    background: rgba(0, 175, 161, 0.14);
    color: #333;
    cursor: pointer;
  }

  .list-title {
    font-weight: bold;
    font-size: 14px;
    color: #333;
    background-color: #f5f5f5;
  }

  .ul__hint {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
</style>
